import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isNumberiramasdbon0i as isNumber } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  add2suhfggl4zvkk as add,
  multiply2k9eolhnz1bjv as multiply,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function plus(_this__u8e3s4, other) {
  var tmp;
  if (typeof _this__u8e3s4 === 'number') {
    var tmp_0 = _this__u8e3s4 + (typeof other === 'number' ? other : THROW_CCE());
    tmp = isNumber(tmp_0) ? tmp_0 : THROW_CCE();
  } else {
    if (typeof _this__u8e3s4 === 'number') {
      var tmp_1 = _this__u8e3s4 + (typeof other === 'number' ? other : THROW_CCE());
      tmp = isNumber(tmp_1) ? tmp_1 : THROW_CCE();
    } else {
      if (typeof _this__u8e3s4 === 'number') {
        var tmp_2 = _this__u8e3s4 + (typeof other === 'number' ? other : THROW_CCE()) | 0;
        tmp = isNumber(tmp_2) ? tmp_2 : THROW_CCE();
      } else {
        if (typeof _this__u8e3s4 === 'bigint') {
          var tmp_3 = add(_this__u8e3s4, typeof other === 'bigint' ? other : THROW_CCE());
          tmp = isNumber(tmp_3) ? tmp_3 : THROW_CCE();
        } else {
          if (typeof _this__u8e3s4 === 'number') {
            var tmp_4 = _this__u8e3s4 + (typeof other === 'number' ? other : THROW_CCE());
            tmp = isNumber(tmp_4) ? tmp_4 : THROW_CCE();
          } else {
            if (typeof _this__u8e3s4 === 'number') {
              var tmp_5 = _this__u8e3s4 + (typeof other === 'number' ? other : THROW_CCE());
              tmp = isNumber(tmp_5) ? tmp_5 : THROW_CCE();
            } else {
              throw IllegalArgumentException().xd();
            }
          }
        }
      }
    }
  }
  return tmp;
}
function times(_this__u8e3s4, other) {
  var tmp;
  if (typeof _this__u8e3s4 === 'number') {
    var tmp_0 = _this__u8e3s4 * (typeof other === 'number' ? other : THROW_CCE()) | 0;
    tmp = isNumber(tmp_0) ? tmp_0 : THROW_CCE();
  } else {
    if (typeof _this__u8e3s4 === 'number') {
      var tmp_1 = _this__u8e3s4 * (typeof other === 'number' ? other : THROW_CCE()) | 0;
      tmp = isNumber(tmp_1) ? tmp_1 : THROW_CCE();
    } else {
      if (typeof _this__u8e3s4 === 'number') {
        var tmp_2 = imul(_this__u8e3s4, typeof other === 'number' ? other : THROW_CCE());
        tmp = isNumber(tmp_2) ? tmp_2 : THROW_CCE();
      } else {
        if (typeof _this__u8e3s4 === 'bigint') {
          var tmp_3 = multiply(_this__u8e3s4, typeof other === 'bigint' ? other : THROW_CCE());
          tmp = isNumber(tmp_3) ? tmp_3 : THROW_CCE();
        } else {
          if (typeof _this__u8e3s4 === 'number') {
            var tmp_4 = _this__u8e3s4 * (typeof other === 'number' ? other : THROW_CCE());
            tmp = isNumber(tmp_4) ? tmp_4 : THROW_CCE();
          } else {
            if (typeof _this__u8e3s4 === 'number') {
              var tmp_5 = _this__u8e3s4 * (typeof other === 'number' ? other : THROW_CCE());
              tmp = isNumber(tmp_5) ? tmp_5 : THROW_CCE();
            } else {
              throw IllegalArgumentException().xd();
            }
          }
        }
      }
    }
  }
  return tmp;
}
//region block: exports
export {
  plus as plus1odefccxt2tsw,
  times as timesygsvtzjjihwo,
};
//endregion

//# sourceMappingURL=numplus.mjs.map
